/** @typedef	{import('./Props').default} Props */

import { BaseSVG } from '../../BaseSVG';
import { translate } from '../../../App/Internationalization';
import images from '../../../config/local/images';
import PopularHeader from '../PopularHeader';
import React from 'react';
import SubscribeButton from '../SubscribeButton';
import SubscriptionPoints from '../SubscriptionPoints';
import SubscriptionPrice from '../SubscriptionPrice/SubscriptionPrice';

/**
 * @param {Props} props
 * @returns {JSX.Element}
 */
function SubscriptionCard(props) {
	const popular = props?.tier?.popular ?? false;

	return (
		<section
			className={`flex flex-col gap-4 text-left border border-theme-dark rounded-lg w-fit p-10`}
		>
			<div className="flex flex-col items-center gap-3">
				<PopularHeader popular={popular ?? false} />
				<i
					className={`flex w-25 icon ${
						popular ? 'icon-fill-fg-light' : ''
					}`}
				>
					<BaseSVG
						className="h-fit"
						path={
							images.icons.subscriptionPlans[props?.tier?.title]
						}
					/>
				</i>

				<p className="font-bold text-ms-4">
					{translate(
						`subscription.plans.${props?.tier?.title}.title`
					)}
				</p>
			</div>

			<p className="h-40 max-h-40 overflow-y-auto font-medium">
				{props?.tier?.description}
			</p>

			<div className="flex justify-center">
				<SubscriptionPrice
					checkoutRole={props?.checkoutRole}
					price={props?.tier?.pricePerMonth}
				/>
			</div>

			<SubscribeButton
				checkoutRole={props?.checkoutRole}
				isGettingData={props?.isGettingData}
				paymentLinks={props?.paymentLinks}
				subscription={props?.subscription}
				tier={props?.tier}
			/>

			<SubscriptionPoints features={props?.tier?.features} />
		</section>
	);
}

export default React.memo(SubscriptionCard);
